import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { selectKeyword, unSelectKeyword, search } from '../../state/actions';
import { StateType } from '../../../state/state.types';

const mapState = ({ queryParams, results }: StateType) => {
  return {
    queryKey: queryParams.originalQueryKey || '',
    selectedKeywords: queryParams.selectedKeywords,
    recommendedKeywords: results.recommendedKeywords
      ? results.recommendedKeywords
      : [],
  };
};

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  selectKeyword(keyword: string) {
    dispatch(selectKeyword(keyword));
    dispatch(search({ reason: 'keywords-suggest' }));
  },
  unSelectKeyword(keyword: string) {
    dispatch(unSelectKeyword(keyword));
    dispatch(search({ reason: 'keywords-suggest' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
